{ "cities": ["Phoenix", "Chicago", "New York", "Los Angeles", "Dallas"] }
